import Link from 'next/link';
import { CityInterface } from '../../api/citiesPage';
import { citiesAmerica, citiesCanada } from './AllCities';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import SwiperCore, { Pagination } from 'swiper';
import Card from '../Card';
SwiperCore.use([Pagination]);

interface AllCities {
  cities: CityInterface[];
  country: string;
}
const CitiesMobile = ({ cities, country }: AllCities) => {
  const countryType = country === 'canada' ? citiesCanada : citiesAmerica;
  return (
    <div className="block md:hidden pl-[8%]">
      <Swiper
        className="swiper_123 relative "
        spaceBetween={40}
        slidesPerView={1}
        effect="slide"
        grabCursor
        a11y={{ enabled: true }}
        observer
        observeParents
        observeSlideChildren
        breakpoints={{
          280: {
            slidesPerView: 1.15,
            spaceBetween: 16
          },
          400: {
            slidesPerView: 1.3,
            spaceBetween: 20
          },
          640: {
            slidesPerView: 1.5,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 1.5,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 2.5
          },
          1200: {
            slidesPerView: 2.5
          }
        }}
      >
        {cities &&
          cities
            .filter(city => countryType.includes(city.city.slug))
            .map((city: any, index: number) => (
              <SwiperSlide key={index}>
                <Link href={`/${city.city.slug}`}>
                  <Card
                    index={index}
                    slug={city.city.slug}
                    image={city.city.cardMedia[0]?.url}
                    cardSnippet={city.city.cardSnippet}
                    city={city.city.name}
                  />
                </Link>
              </SwiperSlide>
            ))}
      </Swiper>
    </div>
  );
};

export default CitiesMobile;
